import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => localStorage.getItem("ruminex_lang") || "es");

    const setLang = useCallback((l) => {
        localStorage.setItem("ruminex_lang", l);
        setLangState(l);
        document.documentElement.lang = l;
    }, []);

    const t = useCallback((key, vars) => {
        const dict = translations[lang] || translations.es;
        let s = dict[key];
        if (s == null) s = translations.es[key] ?? key;
        if (vars) {
            Object.entries(vars).forEach(([k, v]) => {
                s = s.replace(`{${k}}`, String(v));
            });
        }
        return s;
    }, [lang]);

    const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useT() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useT must be used inside I18nProvider");
    return ctx;
}
